module.exports = __webpack_public_path__ + "static/assets/1e42fb0552204ffda375eaf9779df330.ttf";